import React from "react";
import PropTypes from "prop-types";

import IraqTinyMapLoader from "./IraqTinyMapLoader.js";
import USATinyMapLoader from "./USATinyMapLoader.js";
import AfghanistanTinyMapLoader from "./AfghanistanTinyMapLoader.js";

const TinyMapLoader = (props) => {
	// console.log("TinyMapLoader", props);
	// default is usa
	return props.baseMap === "iraq" ? (
		<IraqTinyMapLoader stateName={props.stateName} actions={props.actions} />
	) : props.baseMap === "texas23" ? (
		<USATinyMapLoader stateName={props.stateName} actions={props.actions} />
	) : props.baseMap === "craftsman" ? (
		<AfghanistanTinyMapLoader stateName={props.stateName} actions={props.actions} />
	) : (
		<USATinyMapLoader stateName={props.stateName} actions={props.actions} />
	);
};

TinyMapLoader.propTypes = {
	baseMap: PropTypes.string,
	stateName: PropTypes.string.isRequired,
};

export default TinyMapLoader;
